import { Fragment, h } from 'preact'; /** @jsx h */
import { Checkbox } from './input';
import { datoToText } from './utils';

const VisFravaerTabell = ({ person }) => {
  const showReisetillegg = Object.keys(person.timer).some(
    (dato) => person.timer[dato].reiseid > 0
  );

  return (
    <table className="pa3 w-100 td-l1 mb3-halv">
      <thead className="bt b--black">
        <tr className="tr">
          <th>Dato</th>
          <th>Aktiv arbeidstid</th>
          <th>Passiv reisetid</th>
          {showReisetillegg && <th>Reisetillegg</th>}
        </tr>
      </thead>

      <tbody>
        {Object.keys(person.timer).map((dato, index) => {
          const dag = person.timer[dato];

          return (
            <tr key={index} className="tr">
              <td>{datoToText(dato)}</td>

              {dag.regtim === 'N' ? (
                <Fragment>
                  <td className="pa3" colSpan={2}>
                    Dagen skal ikke registreres med timer
                  </td>

                  {showReisetillegg && (
                    <td>
                      {dag.reiseid > 0 && (
                        <Checkbox
                          label=""
                          name={`ikke_rt_${dato}`}
                          checked={dag.ikke_rt !== 'J'}
                          disabled
                        />
                      )}
                    </td>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  <td>{parseFloat(dag.aktiv)}</td>
                  <td>{parseFloat(dag.passiv)}</td>

                  {showReisetillegg && (
                    <td>
                      {dag.reiseid > 0 && (
                        <Checkbox
                          label=""
                          name={`ikke_rt_${dato}`}
                          checked={dag.ikke_rt !== 'J'}
                          disabled
                        />
                      )}
                    </td>
                  )}
                </Fragment>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default VisFravaerTabell;
